// Size Calculator JavaScript

// Custom Element: SizeDropdown
class SizeDropdown extends HTMLElement {
  constructor() {
    super();

    this.button = this;
    this.dropdown = this.parentNode.querySelector(".js-size-dropdown");
    this.resultCalSizeEle = document.querySelector(".js-calculator-size");
    this.productType = this.button
      .closest(".js-calculator-size-wrap")
      .getAttribute("data-product");

    if (!this.dropdown) return;

    this.button.addEventListener("click", this.toggleDropdown.bind(this));
    this.allSizeOption = this.dropdown.querySelectorAll(".js-cal-size-option");
    if (this.allSizeOption.length > 0) {
      this.allSizeOption.forEach((sizeOption) =>
        sizeOption.addEventListener("click", this.onChangeSize.bind(this))
      );
    }
  }

  toggleDropdown(e) {
    e.stopPropagation();

    if (this.button.classList.contains("opening")) {
      this.hideDropdown();
    } else {
      if (document.querySelectorAll("size-dropdown.opening").length > 0) {
        document
          .querySelector("size-dropdown.opening")
          .classList.remove("opening");
      }

      this.button.classList.add("opening");
      document.body.addEventListener("click", hideDropdown);
    }
  }

  hideDropdown() {
    this.button.classList.remove("opening");

    document.body.removeEventListener("click", hideDropdown);
  }

  onChangeSize(e) {
    e.stopPropagation();
    this.sizeOption = e.currentTarget;
    console.log("here",this.sizeOption);
    
    // Determine which dropdown type this is
    const dropdownType = this.dropdown.getAttribute('data-type');
    console.log('Dropdown type:', dropdownType);

    if (this.sizeOption.parentNode.classList.contains("selected")) {
      this.sizeOption.parentNode
        .querySelector(".js-cal-size-option.selected")
        .classList.remove("selected");
    } else {
      this.sizeOption.parentNode.classList.add("selected");
    }

    this.sizeOption.classList.add("selected");
    this.button.querySelector("span").textContent = this.sizeOption.textContent;

    this.inputsWrap = e.currentTarget.closest(".product-info__size-input");
    if (this.productType == "top") {
      let heightOptionEl = null;
      let weightOptionEl = null;

      // If we just clicked height, use that. Otherwise find the selected one or default
      if (dropdownType === 'height') {
        heightOptionEl = this.sizeOption;
        // Find weight option
        weightOptionEl = this.inputsWrap.querySelector(
          '.js-size-dropdown[data-type="weight"] .js-cal-size-option.selected'
        );
        if (!weightOptionEl) {
          const weightButton = this.inputsWrap.querySelector('.size-dropdown-button[data-type="weight"]');
          if (weightButton) {
            const displayedWeight = weightButton.querySelector('span').textContent.trim();
            const weightOptions = this.inputsWrap.querySelectorAll('.js-size-dropdown[data-type="weight"] .js-cal-size-option');
            for (const option of weightOptions) {
              if (option.textContent.trim() === displayedWeight) {
                weightOptionEl = option;
                break;
              }
            }
          }
        }
      } else if (dropdownType === 'weight') {
        // If we just clicked weight, use that. Otherwise find the selected one or default
        weightOptionEl = this.sizeOption;
        // Find height option
        heightOptionEl = this.inputsWrap.querySelector(
          '.js-size-dropdown[data-type="height"] .js-cal-size-option.selected'
        );
        if (!heightOptionEl) {
          const heightButton = this.inputsWrap.querySelector('.size-dropdown-button[data-type="height"]');
          if (heightButton) {
            const displayedHeight = heightButton.querySelector('span').textContent.trim();
            const heightOptions = this.inputsWrap.querySelectorAll('.js-size-dropdown[data-type="height"] .js-cal-size-option');
            for (const option of heightOptions) {
              if (option.textContent.trim() === displayedHeight) {
                heightOptionEl = option;
                break;
              }
            }
          }
        }
      }

      console.log('Height option:', heightOptionEl ? heightOptionEl.textContent.trim() + ' (index: ' + heightOptionEl.getAttribute('data-index') + ')' : 'NOT FOUND');
      console.log('Weight option:', weightOptionEl ? weightOptionEl.textContent.trim() + ' (index: ' + weightOptionEl.getAttribute('data-index') + ')' : 'NOT FOUND');

      // Only calculate if we have both height and weight
      if (heightOptionEl && weightOptionEl) {
        this.heightOption = heightOptionEl;
        this.weightOption = weightOptionEl;

        // Save both value and index to localStorage
        localStorage.setItem(
          "heightOptionValue",
          this.heightOption.getAttribute("data-value")
        );
        localStorage.setItem(
          "heightOptionIndex",
          this.heightOption.getAttribute("data-index")
        );
        localStorage.setItem(
          "weightOptionValue",
          this.weightOption.getAttribute("data-value")
        );
        localStorage.setItem(
          "weightOptionIndex",
          this.weightOption.getAttribute("data-index")
        );
        console.log('brfore remove',localStorage.getItem('okeheight'));
        localStorage.removeItem('okeheight');
        console.log('after remove',localStorage.getItem('okeheight'));
        console.log('brfore remove',localStorage.getItem('okeweight'));
        localStorage.removeItem('okeweight');
        console.log('after remove',localStorage.getItem('okeweight'));
        this.sizeTop();
      } else {
        console.error('[size-calculator] Missing height or weight option');
      }
    } else {
      this.waistOption = this.sizeOption;

      // Save both value and index to localStorage
      localStorage.setItem(
        "waistOptionValue",
        this.waistOption.getAttribute("data-value")
      );
      localStorage.setItem(
        "waistOptionIndex",
        this.waistOption.getAttribute("data-index")
      );
      console.log('brfore remove',localStorage.getItem('okewaist'));
      localStorage.removeItem('okewaist');
      console.log('after remove',localStorage.getItem('okewaist'));
      this.sizeBottom();
    }

    this.hideDropdown();
  }

  async sizeTop() {
    this.resultCalSize = await calculatorSizeTop(
      parseInt(this.heightOption.getAttribute("data-index")),
      parseInt(this.weightOption.getAttribute("data-index"))
    );

    this.showInfoCal();
  }

  async sizeBottom() {
    this.resultCalSize = await calculatorSizeBottom(
      parseInt(this.waistOption.getAttribute("data-index"))
    );

    this.showInfoCal();
  }

  showInfoCal() {
    console.log('[size-calculator] Updating to size:', this.resultCalSize);
    
    // STEP 1: Update the display text FIRST
    showSizeResult(this.productType, this.resultCalSize);
    
    // STEP 2: Clear ALL previously selected sizes (remove selected classes and visual states)
    const allSizeOptions = document.querySelectorAll('.js-option-size');
    allSizeOptions.forEach((option) => {
      option.classList.remove('is-selected', 'selected');
      option.removeAttribute('checked');
      option.removeAttribute('aria-checked');
      
      // Clear any loading states
      const textSpan = option.querySelector('span:first-child');
      const loadingDiv = option.querySelector('div[x-show]');
      if (textSpan) textSpan.classList.remove('invisible');
      if (loadingDiv) loadingDiv.style.display = 'none';
      
      // Uncheck the associated radio input
      const labelFor = option.getAttribute('for');
      if (labelFor) {
        const radioInput = document.getElementById(labelFor);
        if (radioInput) {
          radioInput.checked = false;
          radioInput.removeAttribute('data-value-selected');
        }
      }
    });

    // STEP 3: Find the new size option that matches our calculated size
    console.log('[size-calculator] Looking for size option with data-size="' + this.resultCalSize + '"');
    const newSizeOptions = document.querySelectorAll(
      '.js-option-size[data-size="' + this.resultCalSize + '"]'
    );
    
    if (newSizeOptions.length === 0) {
      console.error('[size-calculator] Size option not found for:', this.resultCalSize);
      // Text already shown above, just return
      return;
    }

    // Use the first matching size option (usually there's only one per product)
    const newSizeOption = newSizeOptions[0];
    console.log('[size-calculator] Found size option:', newSizeOption);
    
    // Get the variant ID
    const variantId = newSizeOption.dataset.variantProductId || newSizeOption.dataset.variantId;
    
    if (variantId) {
      console.log('[size-calculator] Selecting variant:', variantId);
      
      // STEP 4: Select the new variant
      updateVariantPickers(variantId, newSizeOption);
    } else {
      console.error('[size-calculator] No variant ID found on size option');
    }

    // STEP 4: Display the result text
    showSizeResult(this.productType, this.resultCalSize);
  }
}

customElements.define("size-dropdown", SizeDropdown);

// Preselection Handler for Custom Quiz Integration
document.addEventListener("customOkendoQuiz", function () {
  let okeHeight = localStorage.getItem("okeheight");
  let okeWeight = localStorage.getItem("okeweight"); 
  let okeWaist = localStorage.getItem("okewaist");
  let heightOptionValue = "";
  let heightOptionIndex = "";
  let weightOptionValue = "";
  let weightOptionIndex = "";
  let waistOptionValue = "";
  let waistOptionIndex = "";
  if(okeHeight && okeWeight && okeWaist){
    // Update values from oke selectors
    const heightOption = document.querySelector(`.js-cal-size-option[data-value="${okeHeight}"]`);
    console.log("okeHeight",heightOption);
    
    if (heightOption) {
      heightOptionValue = heightOption.getAttribute("data-value");
      heightOptionIndex = heightOption.getAttribute("data-index");
      console.log("okeHeight",heightOptionValue,heightOptionIndex);
    }

    const weightOption = document.querySelector(`.js-cal-size-option[data-value="${okeWeight}"]`);
    console.log("okeWeight",weightOption);
    if (weightOption) {
      weightOptionValue = weightOption.getAttribute("data-value");
      weightOptionIndex = weightOption.getAttribute("data-index");
      console.log("okeWeight",weightOptionValue,weightOptionIndex);
    }

    const waistOption = document.querySelector(`.js-cal-size-option[data-value="${okeWaist}"]`);
    console.log("okeWaist",waistOption);
    if (waistOption) {
      waistOptionValue = waistOption.getAttribute("data-value");
      waistOptionIndex = waistOption.getAttribute("data-index");
      console.log("okeWaist",waistOptionValue,waistOptionIndex);
    }
  }
  
  if (heightOptionValue && heightOptionIndex)
    preselectSizeOption("height", heightOptionValue, heightOptionIndex);
  if (weightOptionValue && weightOptionIndex)
    preselectSizeOption("weight", weightOptionValue, weightOptionIndex);
  if (waistOptionValue && waistOptionIndex)
    preselectSizeOption("waist", waistOptionValue, waistOptionIndex);

  
  function preselectSizeOption(type, optionValue, optionIndex) {
    let dropdowns = document.querySelectorAll(
      `.js-size-dropdown[data-type="${type}"]`
    );

    if (dropdowns.length) {
      dropdowns.forEach((dropdown) => {
        let optionToSelect = dropdown.querySelector(
          `.js-cal-size-option[data-value="${optionValue}"][data-index="${optionIndex}"]`
        );

        if (optionToSelect) {
          optionToSelect.classList.add("selected");
          let button = dropdown
            .closest(".calculator-size-block")
            .querySelector(".size-dropdown-button span");
          if (button) {
            button.textContent = optionToSelect.textContent;
          }
        }
      });
    }
  }

  // Calculate size after preselecting options
  if (heightOptionIndex && weightOptionIndex) {
    calculatorSizeTop(
      parseInt(heightOptionIndex),
      parseInt(weightOptionIndex)
    ).then((size) => {
      localStorage.setItem("sizeTop", size);
      showSizeResult("top", size);
      if(window.selectSavedSizes) window.selectSavedSizes();
    });
  }

  if (waistOptionIndex) {
    calculatorSizeBottom(parseInt(waistOptionIndex)).then((size) => {
      localStorage.setItem("sizeBottom", size);
      showSizeResult("bottom", size);
      if(window.selectSavedSizes) window.selectSavedSizes();
    });
  }
});

// Preselect size options on page load
document.addEventListener("DOMContentLoaded", function () {
  // Check for saved height and weight options for tops
  let heightOptionValue = localStorage.getItem("heightOptionValue");
  let heightOptionIndex = localStorage.getItem("heightOptionIndex");
  let weightOptionValue = localStorage.getItem("weightOptionValue");
  let weightOptionIndex = localStorage.getItem("weightOptionIndex");
  

  // Check for saved waist option for bottoms
  let waistOptionValue = localStorage.getItem("waistOptionValue");
  let waistOptionIndex = localStorage.getItem("waistOptionIndex");

  let okeHeight = localStorage.getItem("okeheight");
  let okeWeight = localStorage.getItem("okeweight"); 
  let okeWaist = localStorage.getItem("okewaist");
  
  if(okeHeight && okeWeight && okeWaist){
    // Update values from oke selectors
    const heightOption = document.querySelector(`.js-cal-size-option[data-value="${okeHeight}"]`);
    if (heightOption) {
      heightOptionValue = heightOption.getAttribute("data-value");
      heightOptionIndex = heightOption.getAttribute("data-index");
    }

    const weightOption = document.querySelector(`.js-cal-size-option[data-value="${okeWeight}"]`);
    if (weightOption) {
      weightOptionValue = weightOption.getAttribute("data-value");
      weightOptionIndex = weightOption.getAttribute("data-index");
    }

    const waistOption = document.querySelector(`.js-cal-size-option[data-value="${okeWaist}"]`);
    if (waistOption) {
      waistOptionValue = waistOption.getAttribute("data-value");
      waistOptionIndex = waistOption.getAttribute("data-index");
    }
  }
  
  if (heightOptionValue && heightOptionIndex)
    preselectSizeOption("height", heightOptionValue, heightOptionIndex);
  if (weightOptionValue && weightOptionIndex)
    preselectSizeOption("weight", weightOptionValue, weightOptionIndex);
  if (waistOptionValue && waistOptionIndex)
    preselectSizeOption("waist", waistOptionValue, waistOptionIndex);

  
  function preselectSizeOption(type, optionValue, optionIndex) {
    let dropdowns = document.querySelectorAll(
      `.js-size-dropdown[data-type="${type}"]`
    );

    if (dropdowns.length) {
      dropdowns.forEach((dropdown) => {
        let optionToSelect = dropdown.querySelector(
          `.js-cal-size-option[data-value="${optionValue}"][data-index="${optionIndex}"]`
        );

        if (optionToSelect) {
          optionToSelect.classList.add("selected");
          let button = dropdown
            .closest(".calculator-size-block")
            .querySelector(".size-dropdown-button span");
          if (button) {
            button.textContent = optionToSelect.textContent;
          }
        }
      });
    }
  }

  // Calculate size after preselecting options
  if (heightOptionIndex && weightOptionIndex) {
    calculatorSizeTop(
      parseInt(heightOptionIndex),
      parseInt(weightOptionIndex)
    ).then((size) => {
      localStorage.setItem("sizeTop", size);
      showSizeResult("top", size);
      if(window.selectSavedSizes) window.selectSavedSizes();
    });
  }

  if (waistOptionIndex) {
    calculatorSizeBottom(parseInt(waistOptionIndex)).then((size) => {
      localStorage.setItem("sizeBottom", size);
      showSizeResult("bottom", size);
      if(window.selectSavedSizes) window.selectSavedSizes();
    });
  }
});

// Hide dropdown when clicking outside
function hideDropdown() {
  if (document.querySelectorAll("size-dropdown").length > 0) {
    document
      .querySelectorAll("size-dropdown")
      .forEach((dropdown) => dropdown.classList.remove("opening"));
  }
}

// Calculator function for TOPS (Height x Weight matrix)
async function calculatorSizeTop(heightOption, weightOption) {
  let resultCalSize = -2;
  weightOption = weightOption + 1;
  switch (heightOption) {
    case 1:
      // Height: Under 5'8"
      switch (weightOption) {
        case 2:
          resultCalSize = -2;
          break;
        case 3:
          resultCalSize = -1;
          break;
        case 4:
          resultCalSize = 0;
          break;
        case 5:
          resultCalSize = 0;
          break;
        case 6:
          resultCalSize = 0;
          break;
        case 7:
          resultCalSize = 0;
          break;
        case 8:
          resultCalSize = 0;
          break;
        case 9:
          resultCalSize = 0;
          break;
        case 10:
          resultCalSize = 1;
          break;
        case 11:
          resultCalSize = 1;
          break;
        case 12:
          resultCalSize = 2;
          break;
        case 13:
          resultCalSize = 2;
          break;
        case 14:
          resultCalSize = 2;
          break;
        case 15:
          resultCalSize = 2;
          break;
        case 16:
          resultCalSize = 3;
          break;
        case 17:
          resultCalSize = 3;
          break;
        case 18:
          resultCalSize = 3;
          break;
        case 19:
          resultCalSize = 4;
          break;
        case 20:
          resultCalSize = 4;
          break;
        case 21:
          resultCalSize = 4;
          break;
        case 22:
          resultCalSize = 4;
          break;
        case 23:
          resultCalSize = 5;
          break;
        case 24:
          resultCalSize = 5;
          break;
        case 25:
          resultCalSize = 5;
          break;
        case 26:
          resultCalSize = 5;
          break;
        case 27:
          resultCalSize = 5;
          break;
        case 28:
          resultCalSize = 6;
          break;
        case 29:
          resultCalSize = 6;
          break;
        case 30:
          resultCalSize = 6;
          break;
        case 31:
          resultCalSize = 6;
          break;
        case 32:
          resultCalSize = 6;
          break;
        case 33:
          resultCalSize = 6;
          break;
        case 34:
          resultCalSize = 7;
          break;
        case 35:
          resultCalSize = 7;
          break;
        default:
          resultCalSize = -2;
          break;
      }
      break;
    case 2:
      // Height: 5'9 - 5'11"
      switch (weightOption) {
        case 2:
          resultCalSize = -2;
          break;
        case 3:
          resultCalSize = -1;
          break;
        case 4:
          resultCalSize = 0;
          break;
        case 5:
          resultCalSize = 0;
          break;
        case 6:
          resultCalSize = 0;
          break;
        case 7:
          resultCalSize = 0;
          break;
        case 8:
          resultCalSize = 0;
          break;
        case 9:
          resultCalSize = 0;
          break;
        case 10:
          resultCalSize = 1;
          break;
        case 11:
          resultCalSize = 1;
          break;
        case 12:
          resultCalSize = 1;
          break;
        case 13:
          resultCalSize = 2;
          break;
        case 14:
          resultCalSize = 2;
          break;
        case 15:
          resultCalSize = 2;
          break;
        case 16:
          resultCalSize = 3;
          break;
        case 17:
          resultCalSize = 3;
          break;
        case 18:
          resultCalSize = 3;
          break;
        case 19:
          resultCalSize = 4;
          break;
        case 20:
          resultCalSize = 4;
          break;
        case 21:
          resultCalSize = 4;
          break;
        case 22:
          resultCalSize = 4;
          break;
        case 23:
          resultCalSize = 5;
          break;
        case 24:
          resultCalSize = 5;
          break;
        case 25:
          resultCalSize = 5;
          break;
        case 26:
          resultCalSize = 5;
          break;
        case 27:
          resultCalSize = 5;
          break;
        case 28:
          resultCalSize = 5;
          break;
        case 29:
          resultCalSize = 6;
          break;
        case 30:
          resultCalSize = 6;
          break;
        case 31:
          resultCalSize = 6;
          break;
        case 32:
          resultCalSize = 6;
          break;
        case 33:
          resultCalSize = 6;
          break;
        case 34:
          resultCalSize = 7;
          break;
        case 35:
          resultCalSize = 7;
          break;
        default:
          resultCalSize = -2;
          break;
      }
      break;
    case 3:
      // Height: 6'0 - 6'2"
      switch (weightOption) {
        case 2:
          resultCalSize = -2;
          break;
        case 3:
          resultCalSize = -1;
          break;
        case 4:
          resultCalSize = -1;
          break;
        case 5:
          resultCalSize = 0;
          break;
        case 6:
          resultCalSize = 0;
          break;
        case 7:
          resultCalSize = 0;
          break;
        case 8:
          resultCalSize = 0;
          break;
        case 9:
          resultCalSize = 0;
          break;
        case 10:
          resultCalSize = 1;
          break;
        case 11:
          resultCalSize = 1;
          break;
        case 12:
          resultCalSize = 1;
          break;
        case 13:
          resultCalSize = 1;
          break;
        case 14:
          resultCalSize = 1;
          break;
        case 15:
          resultCalSize = 1;
          break;
        case 16:
          resultCalSize = 2;
          break;
        case 17:
          resultCalSize = 2;
          break;
        case 18:
          resultCalSize = 3;
          break;
        case 19:
          resultCalSize = 3;
          break;
        case 20:
          resultCalSize = 3;
          break;
        case 21:
          resultCalSize = 4;
          break;
        case 22:
          resultCalSize = 4;
          break;
        case 23:
          resultCalSize = 4;
          break;
        case 24:
          resultCalSize = 5;
          break;
        case 25:
          resultCalSize = 5;
          break;
        case 26:
          resultCalSize = 5;
          break;
        case 27:
          resultCalSize = 5;
          break;
        case 28:
          resultCalSize = 5;
          break;
        case 29:
          resultCalSize = 6;
          break;
        case 30:
          resultCalSize = 6;
          break;
        case 31:
          resultCalSize = 6;
          break;
        case 32:
          resultCalSize = 6;
          break;
        case 33:
          resultCalSize = 6;
          break;
        case 34:
          resultCalSize = 7;
          break;
        case 35:
          resultCalSize = 7;
          break;
        default:
          resultCalSize = -2;
          break;
      }
      break;
    case 4:
      // Height: 6'3" - 6'5"
      switch (weightOption) {
        case 2:
          resultCalSize = -1;
          break;
        case 3:
          resultCalSize = -1;
          break;
        case 4:
          resultCalSize = -1;
          break;
        case 5:
          resultCalSize = 0;
          break;
        case 6:
          resultCalSize = 0;
          break;
        case 7:
          resultCalSize = 0;
          break;
        case 8:
          resultCalSize = 0;
          break;
        case 9:
          resultCalSize = 0;
          break;
        case 10:
          resultCalSize = 0;
          break;
        case 11:
          resultCalSize = 1;
          break;
        case 12:
          resultCalSize = 1;
          break;
        case 13:
          resultCalSize = 1;
          break;
        case 14:
          resultCalSize = 1;
          break;
        case 15:
          resultCalSize = 1;
          break;
        case 16:
          resultCalSize = 2;
          break;
        case 17:
          resultCalSize = 2;
          break;
        case 18:
          resultCalSize = 3;
          break;
        case 19:
          resultCalSize = 3;
          break;
        case 20:
          resultCalSize = 3;
          break;
        case 21:
          resultCalSize = 4;
          break;
        case 22:
          resultCalSize = 4;
          break;
        case 23:
          resultCalSize = 4;
          break;
        case 24:
          resultCalSize = 4;
          break;
        case 25:
          resultCalSize = 5;
          break;
        case 26:
          resultCalSize = 5;
          break;
        case 27:
          resultCalSize = 5;
          break;
        case 28:
          resultCalSize = 5;
          break;
        case 29:
          resultCalSize = 6;
          break;
        case 30:
          resultCalSize = 6;
          break;
        case 31:
          resultCalSize = 6;
          break;
        case 32:
          resultCalSize = 6;
          break;
        case 33:
          resultCalSize = 6;
          break;
        case 34:
          resultCalSize = 7;
          break;
        case 35:
          resultCalSize = 7;
          break;
        default:
          resultCalSize = -2;
          break;
      }
      break;
    case 5:
      // Height: 6'6" - 6'8"
      switch (weightOption) {
        case 2:
          resultCalSize = -1;
          break;
        case 3:
          resultCalSize = -1;
          break;
        case 4:
          resultCalSize = -1;
          break;
        case 5:
          resultCalSize = 0;
          break;
        case 6:
          resultCalSize = 0;
          break;
        case 7:
          resultCalSize = 0;
          break;
        case 8:
          resultCalSize = 0;
          break;
        case 9:
          resultCalSize = 0;
          break;
        case 10:
          resultCalSize = 0;
          break;
        case 11:
          resultCalSize = 1;
          break;
        case 12:
          resultCalSize = 1;
          break;
        case 13:
          resultCalSize = 1;
          break;
        case 14:
          resultCalSize = 1;
          break;
        case 15:
          resultCalSize = 1;
          break;
        case 16:
          resultCalSize = 2;
          break;
        case 17:
          resultCalSize = 2;
          break;
        case 18:
          resultCalSize = 3;
          break;
        case 19:
          resultCalSize = 3;
          break;
        case 20:
          resultCalSize = 3;
          break;
        case 21:
          resultCalSize = 4;
          break;
        case 22:
          resultCalSize = 4;
          break;
        case 23:
          resultCalSize = 4;
          break;
        case 24:
          resultCalSize = 4;
          break;
        case 25:
          resultCalSize = 5;
          break;
        case 26:
          resultCalSize = 5;
          break;
        case 27:
          resultCalSize = 5;
          break;
        case 28:
          resultCalSize = 5;
          break;
        case 29:
          resultCalSize = 6;
          break;
        case 30:
          resultCalSize = 6;
          break;
        case 31:
          resultCalSize = 6;
          break;
        case 32:
          resultCalSize = 6;
          break;
        case 33:
          resultCalSize = 6;
          break;
        case 34:
          resultCalSize = 7;
          break;
        case 35:
          resultCalSize = 7;
          break;
        default:
          resultCalSize = -2;
          break;
      }
      break;
    case 6:
      // Height: 6'9" - 6"11"
      switch (weightOption) {
        case 2:
          resultCalSize = -1;
          break;
        case 3:
          resultCalSize = -1;
          break;
        case 4:
          resultCalSize = -1;
          break;
        case 5:
          resultCalSize = 0;
          break;
        case 6:
          resultCalSize = 0;
          break;
        case 7:
          resultCalSize = 0;
          break;
        case 8:
          resultCalSize = 0;
          break;
        case 9:
          resultCalSize = 0;
          break;
        case 10:
          resultCalSize = 0;
          break;
        case 11:
          resultCalSize = 1;
          break;
        case 12:
          resultCalSize = 1;
          break;
        case 13:
          resultCalSize = 1;
          break;
        case 14:
          resultCalSize = 1;
          break;
        case 15:
          resultCalSize = 1;
          break;
        case 16:
          resultCalSize = 1;
          break;
        case 17:
          resultCalSize = 2;
          break;
        case 18:
          resultCalSize = 3;
          break;
        case 19:
          resultCalSize = 3;
          break;
        case 20:
          resultCalSize = 3;
          break;
        case 21:
          resultCalSize = 4;
          break;
        case 22:
          resultCalSize = 4;
          break;
        case 23:
          resultCalSize = 3;
          break;
        case 24:
          resultCalSize = 4;
          break;
        case 25:
          resultCalSize = 5;
          break;
        case 26:
          resultCalSize = 5;
          break;
        case 27:
          resultCalSize = 5;
          break;
        case 28:
          resultCalSize = 5;
          break;
        case 29:
          resultCalSize = 6;
          break;
        case 30:
          resultCalSize = 6;
          break;
        case 31:
          resultCalSize = 6;
          break;
        case 32:
          resultCalSize = 6;
          break;
        case 33:
          resultCalSize = 6;
          break;
        case 34:
          resultCalSize = 7;
          break;
        case 35:
          resultCalSize = 7;
          break;
        default:
          resultCalSize = -2;
          break;
      }
      break;
    case 7:
      // Height: 7'0 +
      switch (weightOption) {
        case 2:
          resultCalSize = -1;
          break;
        case 3:
          resultCalSize = -1;
          break;
        case 4:
          resultCalSize = -1;
          break;
        case 5:
          resultCalSize = 0;
          break;
        case 6:
          resultCalSize = 0;
          break;
        case 7:
          resultCalSize = 0;
          break;
        case 8:
          resultCalSize = 0;
          break;
        case 9:
          resultCalSize = 0;
          break;
        case 10:
          resultCalSize = 0;
          break;
        case 11:
          resultCalSize = 1;
          break;
        case 12:
          resultCalSize = 1;
          break;
        case 13:
          resultCalSize = 1;
          break;
        case 14:
          resultCalSize = 1;
          break;
        case 15:
          resultCalSize = 1;
          break;
        case 16:
          resultCalSize = 1;
          break;
        case 17:
          resultCalSize = 2;
          break;
        case 18:
          resultCalSize = 3;
          break;
        case 19:
          resultCalSize = 3;
          break;
        case 20:
          resultCalSize = 3;
          break;
        case 21:
          resultCalSize = 4;
          break;
        case 22:
          resultCalSize = 4;
          break;
        case 23:
          resultCalSize = 3;
          break;
        case 24:
          resultCalSize = 4;
          break;
        case 25:
          resultCalSize = 5;
          break;
        case 26:
          resultCalSize = 5;
          break;
        case 27:
          resultCalSize = 5;
          break;
        case 28:
          resultCalSize = 5;
          break;
        case 29:
          resultCalSize = 6;
          break;
        case 30:
          resultCalSize = 6;
          break;
        case 31:
          resultCalSize = 6;
          break;
        case 32:
          resultCalSize = 6;
          break;
        case 33:
          resultCalSize = 6;
          break;
        case 34:
          resultCalSize = 7;
          break;
        case 35:
          resultCalSize = 7;
          break;
        default:
          resultCalSize = -2;
          break;
      }
      break;
    default:
      resultCalSize = -2;
      break;
  }

  localStorage.setItem("sizeTop", resultCalSize);

  // Optional: Auto-close popup if on pack-builder page
  if (document.body.classList.contains("page-pack-builder")) {
    const bundleContainer = document.querySelector('#product-bundle-container-id');
    console.log(bundleContainer.querySelectorAll('[data-size="' + resultCalSize + '"]'));
    if (
      bundleContainer.querySelectorAll('[data-size="' + resultCalSize + '"]').length >
      0
    ) {
      document.body.classList.remove("popup-size--opening");

      if (
        bundleContainer.querySelectorAll(".js-size-pack-builder.is-active").length > 0
      ) {
        bundleContainer
          .querySelector(".js-size-pack-builder.is-active")
          .classList.remove("is-active");
      }
      let activeElement = bundleContainer.querySelector(
        '[data-size="' + resultCalSize + '"]'
      );
      activeElement.classList.add("is-active");
      let sizeName = activeElement.getAttribute("data-product-size");
      localStorage.setItem("bottoms-product-size", sizeName);
      localStorage.setItem("product-size", sizeName);
    }
  }

  return resultCalSize;
}

// Calculator function for BOTTOMS (Waist-based)
async function calculatorSizeBottom(waistOption) {
  let resultCalSize = "A";
  switch (waistOption) {
    case 1:
      resultCalSize = "A";
      break;
    case 2:
      resultCalSize = "B";
      break;
    case 3:
      resultCalSize = "C";
      break;
    case 4:
      resultCalSize = "D";
      break;
    case 5:
      resultCalSize = "E";
      break;
    case 6:
      resultCalSize = "F";
      break;
    case 7:
      resultCalSize = "G";
      break;
    case 8:
      resultCalSize = "H";
      break;
    default:
      resultCalSize = "A";
      break;
  }

  localStorage.setItem("sizeBottom", resultCalSize);

  // Optional: Auto-close popup if on pack-builder page
  if (document.body.classList.contains("page-pack-builder")) {
    const bundleContainer = document.querySelector('#product-bundle-container-id');
    if (bundleContainer.querySelectorAll('[data-size="' + resultCalSize + '"]').length > 0) {
      document.body.classList.remove("popup-size--opening");
      if (bundleContainer.querySelectorAll(".js-size-pack-builder.is-active").length > 0) {
        bundleContainer
          .querySelector(".js-size-pack-builder.is-active")
          .classList.remove("is-active");
      }
      
      let activeElement = bundleContainer.querySelector(
        '[data-size="' + resultCalSize + '"]'
      );
      activeElement.classList.add("is-active");
      let sizeName = activeElement.getAttribute("data-product-size");
      localStorage.setItem("tops-product-size", sizeName);
      localStorage.setItem("product-size", sizeName);
    }
  }
  return resultCalSize;
}

// Initialize on page load
window.addEventListener("DOMContentLoaded", () => {
  if (
    document.querySelectorAll(".js-modal-size-guide").length > 0 &&
    document.querySelectorAll(".js-trigger-modal-size-guide").length
  ) {
    document
      .querySelector(".js-trigger-modal-size-guide")
      .addEventListener("click", () => {
        document.querySelector(".js-modal-size-guide").click();
      });
  }

  sizePopup();
  checkPredictSize();

  // Open popup if URL has #FindMyFit
  if (window.location.hash == "#FindMyFit") {
    var element = document.querySelector('[data-js-element="find-my-fit"] a');
    if (element) {
      element.click();
    }
  }
});

// Setup popup open/close handlers
function sizePopup() {
  console.log('[size-calculator] sizePopup');
  const findMyFitElements = document.querySelectorAll(
    '[data-js-element="find-my-fit"]'
  );
  console.log('[size-calculator] findMyFitElements', findMyFitElements);

  findMyFitElements.forEach((el) => {
    const link = el.querySelector("a");

    link.addEventListener("click", (e) => e.preventDefault());
    el.addEventListener("click", () => {
      // Close mobile navigation drawer if open
      const closeButton = document.querySelector("dialog-close-button");
      const quickBuyCloseButton = document.querySelector(".quick-buy-modal__close-button");
      console.log('[size-calculator] quickBuyCloseButton', quickBuyCloseButton);
      console.log('[size-calculator] closeButton', closeButton);

      if(closeButton) closeButton.click();
      if (quickBuyCloseButton) {
        quickBuyCloseButton.click();
      }
      // Open fit popup
      setTimeout(() => {
        document.body.classList.add("popup-size--opening");
        
        // IMPORTANT: Refresh dropdown selections from localStorage when popup opens
        refreshDropdownSelections();
      }, 200);
    });
  });

  // Close popup handlers
  const closeSizeElements = document.querySelectorAll(
    '[data-js-element="close-popup"]'
  );

  closeSizeElements.forEach((el) => {
    el.addEventListener("click", () => {
      document.body.classList.remove("popup-size--opening");
    });
  });
}

// Refresh dropdown selections from localStorage (called when popup opens)
function refreshDropdownSelections() {
  console.log('[size-calculator] Refreshing dropdown selections from localStorage');
  
  // Get saved values from localStorage
  const heightOptionValue = localStorage.getItem("heightOptionValue");
  const heightOptionIndex = localStorage.getItem("heightOptionIndex");
  const weightOptionValue = localStorage.getItem("weightOptionValue");
  const weightOptionIndex = localStorage.getItem("weightOptionIndex");
  const waistOptionValue = localStorage.getItem("waistOptionValue");
  const waistOptionIndex = localStorage.getItem("waistOptionIndex");
  
  // Update height dropdown
  if (heightOptionValue && heightOptionIndex) {
    updateDropdownDisplay("height", heightOptionValue, heightOptionIndex);
  }
  
  // Update weight dropdown
  if (weightOptionValue && weightOptionIndex) {
    updateDropdownDisplay("weight", weightOptionValue, weightOptionIndex);
  }
  
  // Update waist dropdown
  if (waistOptionValue && waistOptionIndex) {
    updateDropdownDisplay("waist", waistOptionValue, waistOptionIndex);
  }
}

// Update a specific dropdown's display with the saved selection
function updateDropdownDisplay(type, optionValue, optionIndex) {
  const dropdowns = document.querySelectorAll(
    `.js-size-dropdown[data-type="${type}"]`
  );

  if (dropdowns.length) {
    dropdowns.forEach((dropdown) => {
      // Find the option to select
      const optionToSelect = dropdown.querySelector(
        `.js-cal-size-option[data-value="${optionValue}"][data-index="${optionIndex}"]`
      );

      if (optionToSelect) {
        // Remove selected class from all options in this dropdown
        const allOptions = dropdown.querySelectorAll('.js-cal-size-option');
        allOptions.forEach(opt => opt.classList.remove('selected'));
        
        // Add selected class to the correct option
        optionToSelect.classList.add("selected");
        
        // Update the button text
        const button = dropdown
          .closest(".calculator-size-block")
          .querySelector(".size-dropdown-button span");
        if (button) {
          button.textContent = optionToSelect.textContent;
          console.log(`[size-calculator] Updated ${type} dropdown to: ${optionToSelect.textContent}`);
        }
      }
    });
  }
}

window.sizePopup = sizePopup;

// Check and display saved sizes
function checkPredictSize() {
  if (
    localStorage.getItem("sizeTop") &&
    localStorage.getItem("sizeTop") != ""
  ) {
    let resultCalSizeTops = localStorage.getItem("sizeTop");
    showSizeResult("top", resultCalSizeTops);
  }

  if (
    localStorage.getItem("sizeBottom") &&
    localStorage.getItem("sizeBottom") != ""
  ) {
    let resultCalSizeBottoms = localStorage.getItem("sizeBottom");
    showSizeResult("bottom", resultCalSizeBottoms);
  }
}

// Display size result
function showSizeResult(productType, resultCalSize) {
  const resultCalSizeEle = document.querySelectorAll(
    '.js-calculator-size[data-product="' + productType + '"]'
  );

  if (resultCalSizeEle.length > 0) {
    resultCalSizeEle.forEach((el) => {
      el.textContent = resultCalSize;
      el.closest(".js-result-calculator-size").style.display = "block";
    });
  }
}

// Update variant pickers - GLOBAL helper function
function updateVariantPickers(variantId, sizeOption) {
  console.log(`[size-calculator] updateVariantPickers called with variant: ${variantId}`);
  
  if (!sizeOption) {
    console.log('[size-calculator] No size option provided, trying fallback methods');
    // Update form input directly as fallback
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
        console.log(`[size-calculator] Updated form variant input: ${variantId}`);
      }
    }
    return;
  }

  // Get the label's 'for' attribute to find the radio input
  const labelFor = sizeOption.getAttribute('for');
  if (!labelFor) {
    console.log('[size-calculator] No "for" attribute found on label');
    return;
  }

  // Find the radio input
  const radioInput = document.getElementById(labelFor);
  if (!radioInput) {
    console.log('[size-calculator] Radio input not found:', labelFor);
    return;
  }

  console.log('[size-calculator] Radio input found:', radioInput);
  console.log('[size-calculator] Radio classes:', radioInput.className);
  console.log('[size-calculator] Radio disabled attribute:', radioInput.disabled);
  console.log('[size-calculator] Has disabled class:', radioInput.classList.contains('disabled'));

  // Check if this variant is available/in stock
  const isDisabled = radioInput.classList.contains('disabled') || radioInput.disabled;
  
  console.log('[size-calculator] Is variant disabled/out of stock:', isDisabled);
  
  if (isDisabled) {
    console.log('[size-calculator] ⚠️ Selected variant is OUT OF STOCK, finding next available variant');
    
    // Find all size options (radio inputs in the same group)
    const radioName = radioInput.getAttribute('name');
    console.log('[size-calculator] Radio name:', radioName);
    
    if (radioName) {
      const cleanName = radioName.trim();
      console.log('[size-calculator] Clean radio name:', cleanName);
      
      // Get ALL radio inputs on the page and filter by matching name
      // (can't use querySelectorAll because the name has newline characters)
      const allRadiosOnPage = document.querySelectorAll('input[type="radio"]');
      const allRadios = Array.from(allRadiosOnPage).filter(radio => {
        const thisName = radio.getAttribute('name');
        return thisName && thisName.trim() === cleanName;
      });
      
      console.log('[size-calculator] Found total radios in group:', allRadios.length);
      
      // Find the first available variant
      let nextAvailableRadio = null;
      allRadios.forEach((radio, index) => {
        const hasDisabledClass = radio.classList.contains('disabled');
        const hasDisabledAttr = radio.disabled;
        const isAvailable = !hasDisabledClass && !hasDisabledAttr;
        
        console.log(`[size-calculator] Radio ${index}: id=${radio.id}, disabled class=${hasDisabledClass}, disabled attr=${hasDisabledAttr}, available=${isAvailable}`);
        
        if (isAvailable && !nextAvailableRadio) {
          nextAvailableRadio = radio;
          console.log('[size-calculator] ✓ Found first available variant:', radio.id);
        }
      });
      
      if (nextAvailableRadio) {
        // Use the available variant instead
        const nextLabel = document.querySelector(`label[for="${nextAvailableRadio.id}"]`);
        console.log('[size-calculator] Next available label:', nextLabel);
        
        if (nextLabel) {
          const nextVariantId = nextLabel.dataset.variantProductId || nextLabel.dataset.variantId;
          console.log('[size-calculator] Next variant ID:', nextVariantId);
          
          if (nextVariantId) {
            console.log('[size-calculator] 🔄 Switching to available variant:', nextVariantId);
            // Recursively call with the available variant
            updateVariantPickers(nextVariantId, nextLabel);
            return;
          }
        }
      } else {
        console.log('[size-calculator] ❌ No available variants found - all sold out');
        return;
      }
    }
  } else {
    console.log('[size-calculator] ✓ Variant is IN STOCK, proceeding with selection');
  }

  // Check if data-value-selected is already true (actual selection state)
  const isAlreadySelected = radioInput.getAttribute('data-value-selected') === 'true';
  console.log('[size-calculator] data-value-selected:', radioInput.getAttribute('data-value-selected'));
  console.log('[size-calculator] Is already selected:', isAlreadySelected);

  // Skip only if BOTH checked AND data-value-selected is true
  if (radioInput.checked && isAlreadySelected) {
    console.log('[size-calculator] Radio already checked AND selected, skipping');
    return;
  }

  console.log('[size-calculator] Proceeding with variant selection for:', labelFor);

  // STEP 1: Update data-value-selected on ALL radio inputs in the same group
  const radioName = radioInput.getAttribute('name');
  if (radioName) {
    const cleanName = radioName.trim();
    const allRadiosOnPage = document.querySelectorAll('input[type="radio"]');
    const allRadiosInGroup = Array.from(allRadiosOnPage).filter(radio => {
      const thisName = radio.getAttribute('name');
      return thisName && thisName.trim() === cleanName;
    });
    
    console.log('[size-calculator] Updating data-value-selected for', allRadiosInGroup.length, 'radios in group');
    
    allRadiosInGroup.forEach(radio => {
      if (radio.id === labelFor) {
        radio.setAttribute('data-value-selected', 'true');
        radio.checked = true;
        console.log('[size-calculator] Set data-value-selected=true for:', radio.id);
      } else {
        radio.setAttribute('data-value-selected', 'false');
        radio.checked = false;
      }
    });
  }

  // STEP 2: Update the hidden variant input in the form
  const formId = radioInput.getAttribute('form');
  if (formId) {
    const form = document.getElementById(formId);
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
        console.log('[size-calculator] Updated form variant input to:', variantId);
      }
    }
  }
  
  // Also try updating any form with cart/add action
  const cartForms = document.querySelectorAll('form[action*="/cart/add"]');
  cartForms.forEach(form => {
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;
      console.log('[size-calculator] Updated cart form variant input to:', variantId);
    }
  });

  // STEP 3: Dispatch change event to trigger theme's handlers
  const changeEvent = new Event('change', { bubbles: true });
  radioInput.dispatchEvent(changeEvent);
  console.log('[size-calculator] Dispatched change event');

  // STEP 4: Also try clicking to ensure all handlers fire
  // Use a small delay to avoid conflicts
  setTimeout(() => {
    // Dispatch input event as well (some themes listen for this)
    const inputEvent = new Event('input', { bubbles: true });
    radioInput.dispatchEvent(inputEvent);
    console.log('[size-calculator] Dispatched input event');
  }, 10);

  // Force remove any loading states on this specific element
  // by directly manipulating the classes (bypass Alpine)
  setTimeout(() => {
    const label = document.querySelector(`label[for="${labelFor}"]`);
    if (label) {
      const textSpan = label.querySelector('span:first-child');
      const loadingDiv = label.querySelector('div[x-show]');
      
      if (textSpan) {
        textSpan.classList.remove('invisible');
        console.log('[size-calculator] Removed invisible class from text');
      }
      
      if (loadingDiv) {
        loadingDiv.style.display = 'none';
        console.log('[size-calculator] Hid loading spinner');
      }
    }
  }, 50);

  console.log('[size-calculator] ✓ Variant selection complete');
}

// Select saved sizes on page load
document.addEventListener('DOMContentLoaded', function() {
  if(window.selectSavedSizes) window.selectSavedSizes();
});

// Auto-select size variant on product pages
window.selectSavedSizes = function () {
  console.log('[size-calculator] selectSavedSizes called');
  
  // Get product type (top or bottom) from the calculator on the page
  const getSizeWrapInfo = () => {
    const wrap = document.querySelector(".js-calculator-size-wrap");
    if (!wrap) return null;
    
    const productType = wrap.getAttribute("data-product");
    return {
      productType,
      storageKey: productType === "top" ? "sizeTop" : "sizeBottom"
    };
  };

  // Find the size option element for a given size
  const findSizeOption = (size) => {
    const options = document.querySelectorAll(`.js-option-size[data-size="${size}"]`);
    if (options.length === 0) {
      console.log(`[size-calculator] No size option found for: ${size}`);
      return null;
    }
    console.log(`[size-calculator] Found size option for: ${size}`, options[0]);
    return options[0];
  };

  // Update the browser URL with the variant ID
  const updateVariantUrl = (variantId) => {
    if (!history.replaceState) return;
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('variant', variantId);
    window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
    console.log(`[size-calculator] Updated URL with variant: ${variantId}`);
  };

  // MAIN EXECUTION
  
  // 1. Get the product type (top or bottom)
  const wrapInfo = getSizeWrapInfo();
  if (!wrapInfo) {
    console.log('[size-calculator] No calculator found on page');
    return;
  }

  // 2. Get the saved size from localStorage
  const savedSize = localStorage.getItem(wrapInfo.storageKey);
  if (!savedSize) {
    console.log(`[size-calculator] No saved size found for ${wrapInfo.productType}`);
    return;
  }

  console.log(`[size-calculator] Found saved size: ${savedSize} for ${wrapInfo.productType}`);

  // 3. Find the size option element for this size
  const sizeOption = findSizeOption(savedSize);
  if (!sizeOption) {
    console.log(`[size-calculator] Size option not found for: ${savedSize}`);
    return;
  }
  
  // 4. Get the variant ID from the size option's data attribute
  const variantId = sizeOption.dataset.variantProductId || sizeOption.dataset.variantId;
  if (!variantId) {
    console.log('[size-calculator] No variant ID found on size option');
    return;
  }
  
  console.log(`[size-calculator] Selecting variant: ${variantId}`);
  
  // 5. Select the variant by clicking the size option
  updateVariantPickers(variantId, sizeOption);
  
  // 6. Update the URL with the variant parameter
  updateVariantUrl(variantId);
};

// Re-run after variant picker is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      if(window.selectSavedSizes) window.selectSavedSizes();
    }, 500);
  });
} else {
  setTimeout(() => {
    if(window.selectSavedSizes) window.selectSavedSizes();
  }, 500);
}
